$(document).ready(function(){

    $('.quick-view-btn').on('click', function(event){
        console.log('click');
        var handle = $(this).data('handle')
        const qvURL = `${window.shopUrl}/products/${handle}`;
        // console.log('qvURL ' + qvURL);
        const qvContent = document.querySelector('#quickview_content');  
        fetch(`${qvURL}?view=qv`)
        .then((response) => response.text())
        .then((responseText) => {     
            var product_info = $(responseText, 'text/html');
            var single_product = $('.single_product', product_info);
            $(qvContent).append(single_product);
            console.log('work ')
        })
        .catch(err => { 
            console.log(err);
        });
 
        $('#quickview_modal').addClass('show');
    })
    
    $('button#qv_close_btn, .modal-overly').on('click', function(){
        $('#quickview_modal').removeClass('show');
        $('#quickview_content').empty(); 
    })
})
